import { createSlice } from "@reduxjs/toolkit";
import Api from "services/api";

const initialState = {
  clients: [],
  error: null,
  loader: false,
};

const clientSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    setClients: (state, { payload }) => {
      state.clients = payload ?? [];
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    clearClients: (state) => {
      state.clients = [];
      state.error = null;
      state.loader = false;
    },
  },
});

export const { setClients, setError, setLoader, clearClients } =
  clientSlice.actions;

export const fetchClients = () => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.fetchClient();
    if (result?.status >= 200 && result.status < 300) {
      dispatch(setClients(result.data?.data || []));
    } else {
      dispatch(setError(result.data || "Failed to fetch clients"));
    }
  } catch (error) {
    console.error("fetchClients error:", error);
    dispatch(setError(error?.message || "Something went wrong"));
  }
  dispatch(setLoader(false));
};



export const fetchClientsPaginated = (params = {}) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.fetchClient(params);

    if (result?.status >= 200 && result.status < 300) {
      dispatch(setClients(result.data?.data || []));
      return {
        data: result.data?.data || [],
        last_page: result.data?.last_page || 1,
      };
    } else {
      dispatch(setError(result.data || "Failed to fetch clients"));
      return { data: [], last_page: 1 };
    }
  } catch (error) {
    dispatch(setError(error?.message || "Something went wrong"));
    return { data: [], last_page: 1 };
  } finally {
    dispatch(setLoader(false));
  }
};

export default clientSlice.reducer;
